import axios from "axios";
// import setUserAuthenticationToken from "./setUserAuthenticationToken";

axios.defaults.withCredentials = true;

export default {
    user : {
        register: data =>
            axios.post("/api/user/new_user", {data} )
        ,
        getUserData: data => 
            axios.get("/api/user/getUserData", {data}).then(res=>res.data),
        login: data =>
            axios.post("/api/user/login", {data}, {withCredentials: true}).then(res=>{
                return res.data;
            }),
        logout: data => 
            axios.get("/api/user/logout").then(res => res.data)
        ,
        uploadImage: data =>
            axios({
                method: 'post',
                url: '/api/user/uploadImage',
                data: data
            }).then(res=>res.data),
        changeName: data => 
            axios.post("/api/user/changeName", {data}).then(res=>res.data)
    },
    books: {
        createBook: data => 
            axios.post("/api/books/createBook", {data}).then(res=> {
                return res.data;
            }),
        createBookList: data => 
            axios.post("/api/books/createBookList", {data}).then(res=> {
                return res.data;
            }),
        deleteBook: data => 
            axios.post("/api/books/deleteBook", {data}).then(res=> {
                return res.data;
            }),
        deleteBookl: data => 
            axios.post("/api/books/deleteBookl", {data}).then(res=> {
                return res.data;
            }),
        addToBookList: data => 
            axios.post("/api/books/addToBookList", {data}).then(res=> {
                return res.data;
            }),
        removeBookList: data => 
            axios.post("/api/books/removeBookList", {data}).then(res=> {
                return res.data;
            }),
        uploadBookCover: data => 
            axios({
                method: 'post',
                url: '/api/books/uploadBookCover',
                data: data
            }).then(res=>res.data),
        uploadBookFile: data => 
            axios({
                method: 'post',
                url: '/api/books/uploadBookFile',
                data: data
            }).then(res=>res.data),
        chPag: data => 
            axios.post("/api/books/chPag", {data}).then(res => res.data),
        chCha: data => 
            axios.post("/api/books/chCha", {data}).then(res => res.data),
        chBookTitle: data => 
            axios.post("/api/books/chBookTitle", {data}).then(res => res.data),
        chBooklTitle: data => 
            axios.post("/api/books/chBooklTitle", {data}).then(res => res.data),
        chBooklDescription: data => 
            axios.post("/api/books/chBooklDescription", {data}).then(res => res.data),
        chBookDescription: data => 
            axios.post("/api/books/chBookDescription", {data}).then(res => res.data),
        chRecViewed: data => 
            axios.post("/api/books/chRecViewed", {data}).then(res => res.data),
        chBlRecViewed: data => 
            axios.post("/api/books/chBlRecViewed", {data}).then(res => res.data),
        chTotalChapters: data => 
            axios.post("/api/books/chTotalChapters", {data}).then(res => res.data),
        fetch_a_book: data => 
            axios.post("/api/books/fetch_a_book", {data}).then(res => res.data),
        searchBook: data => 
            axios.post("/api/books/searchBook", {data}).then(res => res.data),
        fetch_books: () => 
            axios.get("/api/books/fetch_books", {withCredentials: true, credentials: 'include'}).then(res => res.data),
        fetch_booklists: () => 
            axios.get("/api/books/fetch_booklists").then(res => res.data)
    }
}